import { Recipe } from './Recipe';

export const recipesRoutes = [{ path: ':recipeId', element: <Recipe /> }];
